import { render, staticRenderFns } from "./PoliceImportTicket.vue?vue&type=template&id=265fcf20&scoped=true&"
import script from "./PoliceImportTicket.vue?vue&type=script&lang=js&"
export * from "./PoliceImportTicket.vue?vue&type=script&lang=js&"
import style0 from "./PoliceImportTicket.vue?vue&type=style&index=0&id=265fcf20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265fcf20",
  null
  
)

export default component.exports